// extracted by mini-css-extract-plugin
export default {"menu":"SidebarContextMenu_menu__Ehuic","option":"SidebarContextMenu_option__6xrQJ","selected":"SidebarContextMenu_selected__Bo8As"};